<blockquote>
  <i class="fas fa-quote-left"></i>
  <p class="quote">{{ quote }}</p>

  <footer>
    <p class="author">{{ author }}</p>
    <p class="occupation">{{ occupation }}</p>
  </footer>
</blockquote>
